import { useEffect } from 'react';

/**
 * Fire the supplied handler when the element held in `ref` is visible
 * and the user clicks an element outside its tree. Derived from:
 * https://stackoverflow.com/a/42234988/2167004
 */
const useAwayClick = (ref, onAwayClick) => {
  useEffect(() => {
    // the below events must be listened to for this hook to be fully
    // functional across desktop and mobile
    const awayClickEvents = ['mousedown', 'touchstart'];

    const onClick = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        onAwayClick(e);
      }
    };

    awayClickEvents.forEach(e => document.addEventListener(e, onClick));

    return () =>
      awayClickEvents.forEach(e => document.removeEventListener(e, onClick));
  }, [ref, onAwayClick]);
};

export default useAwayClick;
